import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { MdDownloadForOffline } from 'react-icons/md'
import { AiTwotoneDelete } from 'react-icons/ai'
import { BsFillArrowUpRightCircleFill } from 'react-icons/bs'

import { client, urlFor } from '../client'
import { fetchUser } from '../utils/fetchUser'

const Pin = ({ pin: { postedBy, image, _id, title, about, destination, save } }) => {
    const [postHovered, setPostHovered] = useState(false)
    const [saved, setSaved] = useState(false)
    const navigate = useNavigate()
    const user = fetchUser()

    const alreadySaved = !!(save?.filter((item) => item.postedBy._id === user?.googleId))?.length

    const deletePin = (id) => {
        client
            .delete(id)
            .then(() => {
                window.location.reload();
            });
    };

    const savePin = (id) => {
        if (!alreadySaved) {

            client
                .patch(id)
                .setIfMissing({ save: [] })
                .insert('after', 'save[-1]', [{
                    _key: uuidv4(),
                    userId: user?.googleId,
                    postedBy: {
                        _type: 'postedBy',
                        _ref: user?.googleId
                    }
                }])
                .commit()
                .then(() => {
                    window.location.reload()
                    // refer 02:49 this fun is implement by hakker
                    setSaved(true)
                })
        }
    }

    return (
        <div className='m-2 mb-3 shadow-lg shadow-black	'>
            <div
                onMouseEnter={() => setPostHovered(true)}
                onMouseLeave={() => setPostHovered(false)}
                onClick={() => navigate(`/pin-detail/${_id}`)}
                className="relative cursor-zoom-in w-auto hover:shadow-lg rounded-lg overflow-hidden transition-all duration-500 ease-in-out"
            >
                <img className='rounded-lg w-full' alt='powli posts' src={urlFor(image).width(250).url()} />
                {postHovered && (
                    <div className="absolute top-0 w-full h-full flex flex-col justify-between p-1 pr-2 pt-2 pb-2 z-50"
                        style={{ height: '100%' }}
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex gap-2">
                                <a
                                    href={`${image?.asset?.url}?dl=`}
                                    download
                                    onClick={(e) => e.stopPropagation()}
                                    className="bg-white w-9 h-9 rounded-full flex items-center justify-center 
                                    text-dark text-xl opacity-75 hover:opacity-100 hover:shadow-md outline-none"
                                >
                                    <MdDownloadForOffline />
                                </a>
                            </div>
                            {
                                (alreadySaved || saved) ? (
                                    <button
                                        type="button"
                                        className="bg-rose-600 opacity-70 hover:opacity-100 text-white font-bold px-5 py-1 text-base rounded-3xl hover:shadow-md outline-none"
                                    >
                                        Saved
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className="bg-rose-600 opacity-70 hover:opacity-100 text-white font-bold px-5 py-1 text-base rounded-3xl hover:shadow-md outline-none"
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            savePin(_id)
                                        }}
                                    >
                                        Save
                                    </button>
                                )
                            }
                        </div>
                        <div className=" flex justify-between items-center gap-2 w-full">
                            {destination ? (
                                <a
                                    href={destination}
                                    target="_blank"
                                    className="bg-white flex items-center gap-2 text-black font-bold p-2 pl-4 pr-4 rounded-full opacity-70 hover:opacity-100 hover:shadow-md"
                                    rel="noreferrer"
                                >
                                    <BsFillArrowUpRightCircleFill />
                                </a>
                            ) : ''}

                            {postedBy?._id === user?.googleId && (
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        deletePin(_id);
                                    }}
                                    className="bg-white p-2 rounded-full w-8 h-8 flex items-center justify-center text-dark opacity-75 hover:opacity-100 outline-none"
                                >
                                    <AiTwotoneDelete />
                                </button>
                            )
                            }
                        </div>
                    </div>
                )}
            </div>
            <Link to={`/user-profile/${postedBy?._id}`} className="flex gap-2 mt-2 mx-2 items-center">
                <img
                    className="w-8 h-8 rounded-full object-cover"
                    src={postedBy?.image}
                    alt="user-profile"
                />
                <p className="font-bold text-gray-500 text-sm capitalize">{title}</p>
            </Link>
            <p className=" mx-2 font-medium text-gray-400 text-xs capitalize pt-2 pb-2">{about?.slice(0, 125)}</p>
        </div>
    )
}

export default Pin

